module.exports = __webpack_public_path__ + "static/media/accessory24.203249c1.webp";